import { Link } from "react-router-dom";
import { getArticlesByCategory, getCategoryImage, getCategoryName } from "@/lib/catalog";
import { useT } from "@/lib/i18n";
import { cdnImage, IMG } from "@/lib/img";

// Artikel-/beslagcategorieën voor de cross-sell-teaser (vaste, logische volgorde).
const SLUGS = ["douche-en-bad", "interieurbeglazing", "vitrine-en-meubelbeslag", "balustrade", "glasartikelen", "ventilatieroosters"];

/** Homepage-sectie: cross-sell naar de artikelen-/beslagkant (officieel Timmers-dealer). */
export function BeslagTeaser() {
  const t = useT();
  const cats = SLUGS.map((slug) => ({
    slug,
    name: getCategoryName(slug) ?? slug,
    img: getCategoryImage(slug),
    count: getArticlesByCategory(slug).length,
  })).filter((c) => c.count > 0);
  if (!cats.length) return null;

  return (
    <section aria-labelledby="beslag-teaser" className="mx-auto max-w-[1600px] px-4 pt-14">
      <div className="flex items-baseline justify-between gap-3">
        <h2 id="beslag-teaser" className="text-lg font-bold text-primary-900 sm:text-2xl">{t("Niet alleen glas — ook beslag & gereedschap")}</h2>
        <Link to="/categorie/glasartikelen" className="shrink-0 text-sm font-semibold text-accent-700 hover:text-accent-700">{t("Alle artikelen")} →</Link>
      </div>
      <p className="mt-2 hidden max-w-2xl text-primary-600 sm:block">
        {t("Doucheglas-beslag, balustrades, scharnieren, kit, glaslatten en gereedschap — compleet uw klus uit één hand.")}
      </p>
      {/* Mobiel: 2 kolommen, hele tegel klikbaar (geen losse pijlknop). */}
      <div className="mt-4 grid grid-cols-2 gap-2.5 sm:mt-6 sm:gap-4 lg:grid-cols-3">
        {cats.map((c) => (
          <Link
            key={c.slug}
            to={`/categorie/${c.slug}`}
            className="group flex flex-col items-center gap-2 rounded-2xl border border-primary-100 bg-white p-3 text-center shadow-sm transition hover:-translate-y-0.5 hover:border-primary-300 hover:shadow-md sm:flex-row sm:gap-4 sm:p-4 sm:text-left"
          >
            <div className="h-16 w-16 shrink-0 overflow-hidden rounded-xl bg-white sm:h-20 sm:w-20">
              {c.img ? (
                <img src={cdnImage(c.img, { w: IMG.thumb })} alt={t(c.name)} width={IMG.thumb} height={IMG.thumb} loading="lazy" decoding="async" className="h-full w-full object-contain p-1" />
              ) : (
                <div className="flex h-full w-full items-center justify-center text-xs text-primary-200">{t("geen foto")}</div>
              )}
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="text-sm font-bold leading-tight text-primary-900 sm:text-base">{t(c.name)}</h3>
              <p className="mt-0.5 text-xs text-primary-600 sm:text-sm">{c.count} {t("artikelen")}</p>
            </div>
            <span className="hidden h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-700 text-white shadow-sm transition group-hover:bg-accent-800 sm:flex">→</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
